"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M2 11.208V9.623h2.424V6.121c0-.937.76-1.697 1.697-1.697h3.502V2h1.585v2.424h1.585V2h1.585v2.424h3.5c.938 0 1.698.76 1.698 1.697v3.502H22v1.585h-2.424v1.585H22v1.585h-2.424v3.5c0 .938-.76 1.698-1.697 1.698h-3.502V22h-1.585v-2.424h-1.585V22H9.622v-2.424h-3.5c-.938 0-1.698-.76-1.698-1.697v-3.502H2v-1.585h2.424v-1.585H2zm6.97 3.822h6.06V8.97H8.97v6.06z" }), "Specifications");
//# sourceMappingURL=Specifications.js.map